import React,{forwardRef} from "react";
import "./footer.css";
import { FaInstagram, FaFacebookF } from "react-icons/fa";
import rotatingImage from "../../assets/img/nav/logo_sin_fondo.webp"; // imagen circular

const Footer= forwardRef((props,ref)=> {
  return (
    <footer ref={ref} className="footer">
      <div className="footer-column rotating-column">
        <img src={rotatingImage} alt="Giro" className="rotating-image" />
      </div>

      <div className="footer-column">
        <h3>Nutrioweb</h3>
        <ul className="footer-links">
            <li>
                <a href="#home">Home</a>
            </li>
            <li>
                <a href="#cursos">Cursos</a>
            </li>
            <li>
                <a href="#Novedades">Novedades</a>
            </li>
            <li>
                <a href="#Registrarte">Registrarte</a>
            </li>

        </ul>        
      </div>

      <div className="footer-column">
        <h3>Nuestras redes</h3>
        <div className="social-icons">
          <a href="https://www.instagram.com" target="_blank" rel="noopener noreferrer">
            <FaInstagram size={24} />
          </a>
          <a href="https://www.facebook.com" target="_blank" rel="noopener noreferrer">
            <FaFacebookF size={24} />
          </a>
        </div>
      </div>

      <div className="footer-column">
        <h3>Nuestros cursos</h3>
        <a href="#cursos">Ver cursos</a>
      </div>
    </footer>
  );
})
export default Footer
